exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fit-to-content {\n  width: 1%;\n  white-space: nowrap;\n}\n#spatialTabsTable > tbody > tr > td {\n  word-break: break-all;\n}\n", ""]);

// exports
